<template>
  <button
    class="base-button"
    :class="customClass"
    :style="styleProp"
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>
<script>
export default {
    name: 'BaseButton',
    props: {
        styleProp: {
            type: Object,
            default: () => {},
        },
        block: {
            type: Boolean,
            default: false,
        },
        inverse: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        customClass() {
            let customClass = '';
            if (this.inverse === true) {
                customClass += ' base-button--inverse';
            }

            if (this.block === true) {
                customClass += ' base-button--block';
            }

            if (this.small === true) {
                customClass += ' base-button--small';
            }

            return customClass;
        },
    },
};
</script>
<style lang="scss">
  @import "../scss/style";
  .base-button{
    background-color: $primary;
    border: solid 1px $primary;
    color: white;
    border-radius: 3px;
    padding: 5px 30px;
    margin: 0 10px;
    transition: all 0.3s;

    &--inverse{
      border: solid 1px $primary;
      background-color: white;
      color: $primary;
      &:hover{
        background-color: $primary;
        color: white;
      }
    }
    &--block{
      display: block;
      width: 100%;
      margin: 0;
    }
    &--small{
      padding: 5px 10px;
      font-size: 0.75rem;
    }
    &[disabled]{
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
</style>
